<template>
	<div class="model1">
		<div class="m1_top_box">
			<div class="m1_echarts1" id="m1_echarts1"></div>
			<div class="m1_echarts_alert" id="m1_echarts_alert"></div>
			<span class="m1_echarts_bar_close">X</span>
		</div>
		<!-- 文章列表部分 -->
		<div class="m1_info_box">
			<div class="m1_search_box">
				<el-cascader
					style="border:1px solid #E7EDE5;border-radius:4px;"
					:options="options"
					@change="changeAreaFn"
					v-model="regionIds"
					:props="props2"
					filterable
					collapse-tags
					clearable
				>
				</el-cascader>
				<el-date-picker
					@change="changeDateFn"
					style="width:250px;border: 1px solid #F3F3F3;margin-left:12px;"
					size="large"
					v-model="dateRaneg"
					unlink-panels
					type="daterange"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
				>
				</el-date-picker>
				<div @click="downloadTable" class="m1_download_data">
					导出数据
				</div>
			</div>
			<ul class="m1_info_ul">
				<el-table
					v-loading="loading"
					element-loading-text="加载中"
					:empty-text="loading == true ? '加载中' : '暂无数据'"
					:fit="true"
					style="width:100%;margin:20px auto;"
					:data="dataList"
					:header-cell-style="headerCellStyle"
					:row-style="tableRowClassName"
					:cell-style="cellStyle"
					border
				>
					<el-table-column
						v-for="(item, index) in dataList[0]"
						:prop="index"
						:label="item"
						:show-overflow-tooltip="true"
						:sortable="false"
						align="center"
						:key="index"
						:min-width="
							tableColumnWidth[index] < 24
								? tableColumnWidth[index] * 16
								: tableColumnWidth[index] * 8
						"
					>
					</el-table-column>
				</el-table>
				<el-empty
					v-if="dataList.length <= 0 && loading == false"
					description="暂无数据!"
				></el-empty>
				<el-empty
					v-if="loading == true"
					description="加载中!"
				></el-empty>
			</ul>
			<div v-if="currentSource" style="font-size: 14px; float: right;">
				来源：{{ currentSource }}
			</div>
			<div class="pagination_box">
				<el-pagination
					v-if="dataList.length > 0"
					@current-change="handleCurrentChange"
					:current-page="currentPage"
					:page-size="pagesize"
					layout="total, prev, pager, next, jumper"
					:total="total"
				>
				</el-pagination>
			</div>
		</div>
	</div>
</template>
<script>
import api from '@/../static/common/api/api.js';
import magic from '@/../static/common/magic.js';
import $ from 'jquery';
import echarts from '@/../static/plugins/echarts/echarts.js';
import worldJson from '@/../static/plugins/chinese-map/static/map/world.json';
import axios from 'axios';

export default {
	// 能源展示数据--全国各省
	props: ['currentChoose', 'currentSource', 'currentModel'],
	components: {},
	data() {
		return {
			dateRaneg: [], //日期
			startDate: '', //日历开始时间
			endDate: '', //日历结束时间
			dataType: '', //时间选项 0是 一周 1 是一个月 2 是一年 不限 ''
			currentPage: 1, //当前页
			total: 0, //总页数
			pagesize: 10, //每页条数
			dataList: [], //文章列表数据
			tableColumnWidth: [], //表格各个列最大宽度
			loading: false, //表格加载
			props2: { multiple: true }, //选择器数据
			regionIds: '', //当前传值选中的地区
			options: [
				{
					value: 1,
					label: '东南',
					children: [
						{
							value: 2,
							label: '上海',
							children: [
								{ value: 3, label: '普陀' },
								{ value: 4, label: '黄埔' },
								{ value: 5, label: '徐汇' },
							],
						},
					],
				},
				{
					value: 17,
					label: '西北',
					children: [
						{
							value: 18,
							label: '陕西',
							children: [
								{ value: 19, label: '西安' },
								{ value: 20, label: '延安' },
							],
						},
					],
				},
			],
			maps: {
				bigNum: 0, //当前地图数据里的最大值
			},
		};
	},
	watch: {
		currentChoose(val) {
			this.regionIds = '';
			this.currentPage = 1;
			this.fetchDataList(val); //获取文章列表
			this.fetchAreaDataList(val);
			this.drawWorldMap();
			this.echartsfn2('中国'); //每次进来默认展示北京数据

			$('.m1_echarts_alert').css('display', 'block');
			$('.m1_echarts_bar_close').css('display', 'block');
		},
		//时间段清零函数
		dateRaneg(val) {
			if (val == null) {
				this.startDate = '';
				this.endDate = '';

				this.currentPage = 1;
				this.fetchDataList(this.currentChoose);
			}
			//console.log(val, 'test');
		},
	},
	computed: {},
	created() {
		$('.el-range-editor.el-input__inner').css(
			'border',
			'1px solid #F3F3F3!important'
		);
	},
	mounted() {
		setTimeout(() => {
			$('.el-range-editor--small.el-input__inner').css(
				'border',
				'1px solid #F3F3F3'
			);
			$('.el-pagination__editor.el-input .el-input__inner').css(
				'border',
				'1px solid #E6E6E6!important'
			);
			$('.el-range-editor.el-input__inner').css(
				'border',
				'1px solid #F3F3F3!important'
			);
		}, 2000);

		this.fetchDataList(this.currentChoose);
		this.fetchAreaDataList(this.currentChoose);

		this.drawWorldMap();
		setTimeout(() => {
			this.echartsfn2('中国'); //每次进来默认展示北京数据
		}, 200);
	},
	methods: {
		//点击下载按钮
		downloadTable() {
			let _this = this;
			let tmp_regionIds = [
				...new Set(this.regionIds.toString().split(',')),
			].toString();
			let params = {
				indexId: _this.currentChoose,
				pagesize: this.pagesize,
				curpage: this.currentPage,
				start: this.startDate,
				end: this.endDate,
				regionIds: tmp_regionIds,
				type: '1',
			};

			axios({
				method: 'post',
				url: window.normalUrl + '/down/downEnergyData', // 请求地址
				data: params,
				responseType: 'arraybuffer',
				observe: 'response',
			}).then((res) => {
				const fileName = decodeURIComponent(
					res.headers['content-disposition']
						.split(';')[1]
						.split('=')[1]
				);
				let blob = new Blob([res.data], {
					type:
						'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
				});
				// //console.log(decodeURIComponent(res.headers['content-disposition'].split(';')[1].split('=')[1]),'blob');
				if ('download' in document.createElement('a')) {
					// 非IE下载
					const elink = document.createElement('a');
					elink.download = fileName;
					elink.style.display = 'none';
					elink.href = URL.createObjectURL(blob);
					document.body.appendChild(elink);
					elink.click();
					URL.revokeObjectURL(elink.href); // 释放URL 对象
					document.body.removeChild(elink);
				} else {
					// IE10+下载
					navigator.msSaveBlob(blob, fileName);
					// navigator.msSaveBlob(blob);
				}
			});
		},
		//选中某个地区函数
		changeAreaFn(val) {
			// let str = '';
			// if(val.length > 0){
			//     for(let i=0;i<val.length;i++){
			//         if(val[i].length >= 1){
			//             str += val[i][val[i].length - 1] + ',';
			//         }
			//     }
			// }
			// this.regionIds = str;
			this.currentPage = 1;
			this.fetchDataList(this.currentChoose);
			// //console.log(str,'val-fn');
		},
		//table的单元格样式
		cellStyle(row, column, rowIndex, columnIndex) {
			//styles
			let _this = this;
			if (row.rowIndex % 2 == 0 && row.rowIndex > 0) {
				return 'background:#F5F7F5;';
			}
			if (row.rowIndex == 0) {
				return 'color: #333333;font-weight:bold;font-family:Microsoft YaHei;background:#F7F7F7;display:none;';
			}
		},
		//获取表格每一列的文字最大长度
		getMaxTableWidthFn(data) {
			let _this = this;
			let tmpLen = Object.keys(data[0]).length;
			let arr = [];
			for (let i = 0; i < tmpLen; i++) {
				arr.push([]);
			}
			for (let i = 0; i < data.length; i++) {
				for (let item in data[i]) {
					let len = _this.chkstrlen(String(data[i][item]));
					arr[item].push(len);
				}
			}
			_this.tableColumnWidth = [];
			for (let i = 0; i < arr.length; i++) {
				_this.tableColumnWidth.push(Math.max(...arr[i]));
			}
		},
		//判断是否是汉字
		chkstrlen(str) {
			let strlen = 0;
			for (let i = 0; i < str.length; i++) {
				if (str.charCodeAt(i) > 255) {
					//如果是汉字，则字符串长度加2
					strlen += 2;
				} else {
					strlen++;
				}
			}
			return strlen;
		},
		// table表格样式
		headerCellStyle({ row, rowIndex }) {
			return 'background:#F5F7F5;color:#222222;';
		},
		tableRowClassName({ row, rowIndex }) {
			if (rowIndex % 2 == 0) {
				return 'background:#F5F7F5!important;';
			}
			return '';
		},
		// 世界地图 min, max色阶的最大最小值
		drawWorldMap() {
			let _this = this;
			echarts.registerMap('world', worldJson);
			let myChart = echarts.init(document.getElementById('m1_echarts1'));
			var option;
			let nameMap = {
				Afghanistan: '阿富汗',
				Singapore: '新加坡',
				Angola: '安哥拉',
				Albania: '阿尔巴尼亚',
				'United Arab Emirates': '阿联酋',
				Argentina: '阿根廷',
				Armenia: '亚美尼亚',
				'French Southern and Antarctic Lands': '法属南半球和南极领地',
				Australia: '澳大利亚',
				Austria: '奥地利',
				Azerbaijan: '阿塞拜疆',
				Burundi: '布隆迪',
				Belgium: '比利时',
				Benin: '贝宁',
				'Burkina Faso': '布基纳法索',
				Bangladesh: '孟加拉国',
				Bulgaria: '保加利亚',
				'The Bahamas': '巴哈马',
				'Bosnia and Herzegovina': '波斯尼亚和黑塞哥维那',
				Belarus: '白俄罗斯',
				Belize: '伯利兹',
				Bermuda: '百慕大',
				Bolivia: '玻利维亚',
				Brazil: '巴西',
				Brunei: '文莱',
				Bhutan: '不丹',
				Botswana: '博茨瓦纳',
				'Central African Republic': '中非共和国',
				Canada: '加拿大',
				Switzerland: '瑞士',
				Chile: '智利',
				China: '中国',
				'Ivory Coast': '象牙海岸',
				Cameroon: '喀麦隆',
				'Democratic Republic of the Congo': '刚果民主共和国',
				'Dem. Rep. Congo': '刚果民主共和国',
				'Republic of the Congo': '刚果共和国',
				Colombia: '哥伦比亚',
				'Costa Rica': '哥斯达黎加',
				Cuba: '古巴',
				'Northern Cyprus': '北塞浦路斯',
				Cyprus: '塞浦路斯',
				'Czech Republic': '捷克共和国',
				Germany: '德国',
				Djibouti: '吉布提',
				Denmark: '丹麦',
				'Dominican Republic': '多明尼加共和国',
				Algeria: '阿尔及利亚',
				Ecuador: '厄瓜多尔',
				Egypt: '埃及',
				Eritrea: '厄立特里亚',
				Spain: '西班牙',
				Estonia: '爱沙尼亚',
				Ethiopia: '埃塞俄比亚',
				Finland: '芬兰',
				Fiji: '斐',
				'Falkland Islands': '福克兰群岛',
				France: '法国',
				Gabon: '加蓬',
				'United Kingdom': '英国',
				Georgia: '格鲁吉亚',
				Ghana: '加纳',
				Guinea: '几内亚',
				Gambia: '冈比亚',
				'Guinea Bissau': '几内亚比绍',
				Greece: '希腊',
				Greenland: '格陵兰',
				Guatemala: '危地马拉',
				'French Guiana': '法属圭亚那',
				Guyana: '圭亚那',
				Honduras: '洪都拉斯',
				Croatia: '克罗地亚',
				Haiti: '海地',
				Hungary: '匈牙利',
				Indonesia: '印度尼西亚',
				India: '印度',
				Ireland: '爱尔兰',
				Iran: '伊朗',
				Iraq: '伊拉克',
				Iceland: '冰岛',
				Israel: '以色列',
				Italy: '意大利',
				Jamaica: '牙买加',
				Jordan: '约旦',
				Japan: '日本',
				Kazakhstan: '哈萨克斯坦',
				Kenya: '肯尼亚',
				Kyrgyzstan: '吉尔吉斯斯坦',
				Cambodia: '柬埔寨',
				Kosovo: '科索沃',
				Kuwait: '科威特',
				Laos: '老挝',
				Lebanon: '黎巴嫩',
				Liberia: '利比里亚',
				Libya: '利比亚',
				'Sri Lanka': '斯里兰卡',
				Lesotho: '莱索托',
				Lithuania: '立陶宛',
				Luxembourg: '卢森堡',
				Latvia: '拉脱维亚',
				Morocco: '摩洛哥',
				Moldova: '摩尔多瓦',
				Madagascar: '马达加斯加',
				Mexico: '墨西哥',
				Macedonia: '马其顿',
				Mali: '马里',
				Myanmar: '缅甸',
				Montenegro: '黑山',
				Mongolia: '蒙古',
				Mozambique: '莫桑比克',
				Mauritania: '毛里塔尼亚',
				Malawi: '马拉维',
				Malaysia: '马来西亚',
				Namibia: '纳米比亚',
				'New Caledonia': '新喀里多尼亚',
				Niger: '尼日尔',
				Nigeria: '尼日利亚',
				Nicaragua: '尼加拉瓜',
				Netherlands: '荷兰',
				Norway: '挪威',
				Nepal: '尼泊尔',
				'New Zealand': '新西兰',
				Oman: '阿曼',
				Pakistan: '巴基斯坦',
				Panama: '巴拿马',
				Peru: '秘鲁',
				Philippines: '菲律宾',
				'Papua New Guinea': '巴布亚新几内亚',
				Poland: '波兰',
				'Puerto Rico': '波多黎各',
				'North Korea': '北朝鲜',
				Portugal: '葡萄牙',
				Paraguay: '巴拉圭',
				Qatar: '卡塔尔',
				Romania: '罗马尼亚',
				Russia: '俄罗斯',
				Rwanda: '卢旺达',
				'Western Sahara': '西撒哈拉',
				'Saudi Arabia': '沙特阿拉伯',
				Sudan: '苏丹',
				'South Sudan': '南苏丹',
				'S. Sudan': '南苏丹',
				Senegal: '塞内加尔',
				'Solomon Islands': '所罗门群岛',
				'Sierra Leone': '塞拉利昂',
				'El Salvador': '萨尔瓦多',
				Somaliland: '索马里兰',
				Somalia: '索马里',
				'Republic of Serbia': '塞尔维亚',
				Suriname: '苏里南',
				Slovakia: '斯洛伐克',
				Slovenia: '斯洛文尼亚',
				Sweden: '瑞典',
				Swaziland: '斯威士兰',
				Syria: '叙利亚',
				Chad: '乍得',
				Togo: '多哥',
				Thailand: '泰国',
				Tajikistan: '塔吉克斯坦',
				Turkmenistan: '土库曼斯坦',
				'East Timor': '东帝汶',
				'Trinidad and Tobago': '特里尼达和多巴哥',
				Tunisia: '突尼斯',
				Turkey: '土耳其',
				'United Republic of Tanzania': '坦桑尼亚',
				Uganda: '乌干达',
				Ukraine: '乌克兰',
				Uruguay: '乌拉圭',
				'United States': '美国',
				Uzbekistan: '乌兹别克斯坦',
				Venezuela: '委内瑞拉',
				Vietnam: '越南',
				Vanuatu: '瓦努阿图',
				'West Bank': '西岸',
				Yemen: '也门',
				'South Africa': '南非',
				Zambia: '赞比亚',
				Korea: '韩国',
				Tanzania: '坦桑尼亚',
				Zimbabwe: '津巴布韦',
				Congo: '刚果',
				'Central African Rep.': '中非',
				Serbia: '塞尔维亚',
				"Côte d'Ivoire": '科特迪瓦共和国',
				'Bosnia and Herz.': '波黑',
				'Czech Rep.': '捷克',
				'W. Sahara': '西撒哈拉',
				'Lao PDR': '老挝',
				'Dem. Rep. Korea': '朝鲜',
				'Falkland Is.': '福克兰群岛',
				'Timor-Leste': '东帝汶',
				'Solomon Is.': '所罗门群岛',
				Palestine: '巴勒斯坦',
				'N. Cyprus': '北塞浦路斯',
				Aland: '奥兰群岛',
				'Fr. S. Antarctic Lands': '法属南半球和南极陆地',
				Mauritius: '毛里求斯',
				Comoros: '科摩罗',
				'Eq. Guinea': '赤道几内亚',
				'Guinea-Bissau': '几内亚比绍',
				'Dominican Rep.': '多米尼加',
				'Saint Lucia': '圣卢西亚',
				Dominica: '多米尼克',
				'Antigua and Barb.': '安提瓜和巴布达',
				'U.S. Virgin Is.': '美国原始岛屿',
				Montserrat: '蒙塞拉特',
				Grenada: '格林纳达',
				Barbados: '巴巴多斯',
				Samoa: '萨摩亚',
				Bahamas: '巴哈马',
				'Cayman Is.': '开曼群岛',
				'Faeroe Is.': '法罗群岛',
				'IsIe of Man': '马恩岛',
				Malta: '马耳他共和国',
				Jersey: '泽西',
				'Cape Verde': '佛得角共和国',
				'Turks and Caicos Is.': '特克斯和凯科斯群岛',
				'St. Vin. and Gren.': '圣文森特和格林纳丁斯',
				'S. Geo. and S. Sandw. Is.': '南乔治岛和南桑威群岛',
			};

			//地图数据值
			let _data = [
				{ name: '萨摩亚', value: 3427985 },
				{ name: '乌克兰', value: 59834567 },
				{ name: '越南', value: 53589 },
				{ name: '新西兰', value: 93456 },
				{ name: '墨西哥', value: 19856 },
				{ name: '美国', value: 9876576 },
				{ name: '巴拿马', value: 36789 },
				{ name: '澳大利亚', value: 945783 },
				{ name: '阿富汗', value: 734567 },
				{ name: '新加坡', value: 546923 },
				{ name: '安哥拉', value: 54345 },
				{ name: '阿尔巴尼亚', value: 75678 },
				{ name: '阿联酋', value: 98797 },
				{ name: '阿根廷', value: 127896 },
				{ name: '亚美尼亚', value: 367892 },
				{ name: '中国', value: 7876769 },
				{ name: '俄罗斯', value: 59834572 },
				{ name: '加拿大', value: 5983457 },
			];
			option = {
				// 图表主标题
				title: {
					show: false,
					text: '世界地图', // 主标题文本，支持使用 \n 换行
					//top: 20, // 定位 值: 'top', 'middle', 'bottom' 也可以是具体的值或者百分比
					left: 'center', // 值: 'left', 'center', 'right' 同上
					textStyle: {
						// 文本样式
						fontSize: 18,
						fontWeight: 600,
						color: 'black',
					},
				},
				grid: {
					left: '2%',
					right: '2%',
					bottom: '6%',
					top: '6%',
					containLabel: true,
				},
				tooltip: {
					show: true,
					trigger: 'item',
					formatter: function(params) {
						if (params.name) {
							return (
								params.name +
								' : ' +
								(isNaN(params.value)
									? 0
									: parseInt(params.value))
							);
						}
					},
				},
				// 视觉映射组件
				visualMap: {
					type: 'continuous', // continuous 类型为连续型  piecewise 类型为分段型
					show: true, // 是否显示 visualMap-continuous 组件 如果设置为 false，不会显示，但是数据映射的功能还存在
					// 指定 visualMapContinuous 组件的允许的最小/大值。'min'/'max' 必须用户指定。
					// [visualMap.min, visualMax.max] 形成了视觉映射的『定义域』
					right: '0',
					// 文本样式
					textStyle: {
						fontSize: 14,
						color: 'transparent',
					},
					realtime: false, // 拖拽时，是否实时更新
					calculable: true, // 是否显示拖拽用的手柄
					// 定义 在选中范围中 的视觉元素
					inRange: {
						color: ['#ebdecb', '#8aa87d', '#7d97a8'],
					},
				},
				series: [
					{
						name: 'World',
						type: 'map',
						mapType: 'world',
						roam: true,
						zoom: 1.2,
						itemStyle: {
							// areaColor: '#ccc', // 地图区域的颜色 如果设置了visualMap，areaColor属性将不起作用
							borderWidth: 1, // 描边线宽 为 0 时无描边
							borderColor: '#9c978b', // 图形的描边颜色 支持的颜色格式同 color，不支持回调函数
							borderType: 'solid', // 描边类型，默认为实线，支持 'solid', 'dashed', 'dotted'
							emphasis: {
								label: { show: true },
								areaColor: '#C4E7C0',
								borderWidth: 1,
								borderColor: '#4EAC41',
							},
						},
						label: {
							show: false, // 是否显示对应地名
							emphasis: {
								show: true,
								areaColor: '#C4E7C0',
							},
						},
						data: _data,
						nameMap: nameMap,
					},
				],
			};

			//获取当前地图数据值
			//type，0：全国，1：全球
			let params = {
				indexId: _this.currentChoose,
				type: '1',
				showType: _this.currentModel,
			};
			api.getGraphMapData(params).then((res) => {
				let d = res.data ? res.data.data : [];

				_this.maps.bigNum = 0;

				if (d.length > 0) {
					for (let i = 0; i < d.length; i++) {
						d[i].value > _this.maps.bigNum
							? (_this.maps.bigNum = d[i].value)
							: ''; //获取最大值
					}
				}

				option.tooltip.formatter = function(params) {
					if (params.data) {
						return (
							res.data.date +
							'：' +
							params.data.value +
							res.data.unitName
						);
					}
				};

				option.visualMap.max = _this.maps.bigNum + 5;

				option.series[0].data = d;

				option && myChart.setOption(option);
			});

			//地图点击事件
			myChart.off('click');
			myChart.on('click', function(params) {
				$('.m1_echarts_alert').css('display', 'block');
				$('.m1_echarts_bar_close').css('display', 'block');
				//console.log(params, 'params');
				params.data && params.data.name
					? _this.echartsfn2(params.data.name)
					: '';
			});

			$('.m1_echarts_bar_close').off('click');
			$('.m1_echarts_bar_close').on('click', function(params) {
				$('.m1_echarts_bar_close').css('display', 'none');
				$('.m1_echarts_alert').css('display', 'none');
			});
		},
		// 柱状图
		echartsfn2(name) {
			var chartDom = document.getElementById('m1_echarts_alert');
			var myChart = echarts.init(chartDom);

			var option = {
				color: ['#42A15B'],
				title: {
					text: 'aaaaaaaaa',
					left: 'center',
					textStyle: { fontSize: 14, fontWeight: 'normal' },
				},
				grid: {
					left: '2%',
					right: '2%',
					bottom: '6%',
					top: '12%',
					containLabel: true,
				},
				tooltip: {
					show: true,
					trigger: 'axis',
					formatter: '{b}： {c}',
				},
				xAxis: {
					type: 'category',
					data: [],
					axisLine: {
						lineStyle: {
							color: '#CCCCCC',
							width: 1, //这里是为了突出显示加上的
						},
					},
					axisLabel: {
						// X轴线 标签修改
						textStyle: {
							color: '#4D4D4D', //坐标值得具体的颜色
						},
					},
					splitLine: {
						show: true, // X轴线 颜色类型的修改
						lineStyle: {
							type: 'dashed',
							color: '#F2F2F2',
						},
					},
				},
				yAxis: {
					type: 'value',
					axisLine: {
						lineStyle: {
							color: '#CCCCCC',
							width: 1, //这里是为了突出显示加上的
						},
					},
					axisLabel: {
						// X轴线 标签修改
						textStyle: {
							color: '#4D4D4D', //坐标值得具体的颜色
						},
					},
					splitLine: {
						show: true, // X轴线 颜色类型的修改
						lineStyle: {
							type: 'dashed',
							color: '#F2F2F2',
						},
					},
				},
				series: [
					{
						data: [],
						type: 'bar',
						barWidth: 10,
						showBackground: true,
						backgroundStyle: {
							color: 'rgba(180, 180, 180, 0.2)',
						},
					},
				],
			};

			let params = {
				indexId: this.currentChoose,
				regionName: name,
				type: '1',
				showType: this.currentModel,
			};

			api.getGraphBarMapData(params).then((res) => {
				option.series[0].data = res.data.xList.reverse();
				option.xAxis.data = res.data.yList.reverse();
				option.tooltip.formatter =
					'{b}： {c}' + (res.data.unitName ? res.data.unitName : '');
				option.title.text = res.data.title;
				//console.log(option, 'option');
				// setTimeout(()=>{
				if (res.data.xList.length > 0) {
					option && myChart.setOption(option);
				} else {
					$('.m1_echarts_alert').css('display', 'none');
					$('.m1_echarts_bar_close').css('display', 'none');
				}
				// },400);
			});
		},
		// 点击日历切换函数
		changeDateFn(res) {
			if (this.dateRaneg.length > 0) {
				let startDate = magic.TimestampToDateTime(res[0]);
				let endDate = magic.TimestampToDateTime(res[1]);

				startDate
					? (this.startDate = startDate.substring(0, 10))
					: (this.startDate = '');
				endDate
					? (this.endDate = endDate.substring(0, 10))
					: (this.endDate = '');

				this.currentPage = 1;
				this.fetchDataList(this.currentChoose);
			}
		},
		//获取表格数据
		fetchDataList(_id) {
			let _this = this;
			//type，0：全国，1：全球
			let tmp_regionIds = [
				...new Set(this.regionIds.toString().split(',')),
			].toString();
			let params = {
				indexId: _id,
				pagesize: this.pagesize,
				curpage: this.currentPage,
				start: this.startDate,
				end: this.endDate,
				regionIds: tmp_regionIds,
				type: '1',
			};
			this.loading = true;
			api.getGraphListData(params).then((res) => {
				//console.log(res, 'list');

				_this.dataList = res.data.rows;
				_this.getMaxTableWidthFn(res.data.rows);
				_this.total = res.data.total;
				setTimeout(() => {
					_this.loading = false;
				}, 100);
			});
		},
		//获取地区选项数据
		fetchAreaDataList(_id) {
			var _id = 2;
			let _this = this;
			api.getRegionList(_id).then((res) => {
				//console.log(res, 'area');
				_this.options = res.data;
			});
		},
		//翻页
		handleCurrentChange(val) {
			this.currentPage = val;
			this.fetchDataList(this.currentChoose);
		},
	},
	filters: {
		subData1: function(value) {
			return value.substring(0, 7);
		},
		subData2: function(value) {
			return value.substring(8, 10);
		},
	},
};
</script>
<style scoped lang="less">
.model1 {
	width: 890px;
	height: 100%;
	overflow: hidden;
	padding: 14px 30px;
	background: #fff;
}

.m1_top_box {
	width: 100%;
	overflow: hidden;
	position: relative;
}

.m1_echarts_box {
	width: 100%;
	overflow: hidden;
	margin-top: 85px;
}
.m1_echarts1 {
	width: 890px;
	// height: 560px;
	height: 637px;
	float: left;
	background: radial-gradient(circle, #f5f7f5, #d9dbd9);
	margin-top: 17px;
}
.m1_echarts_alert {
	width: 313px;
	height: 196px;
	background: #ffffff;
	border: 1px solid #dbdbdb;
	box-shadow: 0px 0px 27px 0px rgba(190, 193, 189, 0.75);
	border-radius: 2px;
	position: absolute;
	bottom: 0;
	left: 0;
	z-index: 1000;
	// display: none;
}
.m1_echarts_bar_close {
	position: absolute;
	bottom: 181px;
	left: 299px;
	display: block;
	width: 25px;
	height: 25px;
	border: 1px solid #ccc;
	z-index: 2000;
	text-align: center;
	line-height: 26px;
	border-radius: 50%;
	background: #fff;
	cursor: pointer;
}
//文章列表部分
.m1_info_box {
	width: 100%;
	overflow: hidden;
	position: relative;
}
.m1_info_box h5 {
	width: 100%;
	height: 70px;
	line-height: 70px;
	border-bottom: 1px solid #e7ede5;
	font-size: 16px;
	font-family: Source Han Sans CN;
	font-weight: 500;
	color: #222222;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	-o-text-overflow: ellipsis;
	margin-top: 30px;
}
.m1_info_box h5 img {
	height: 18px;
	display: inline-block;
	margin-right: 5px;
	vertical-align: middle;
}
// 搜索框部分
.m1_search_box {
	width: 100%;
	line-height: 32px;
	margin-top: 22px;
	overflow: hidden;
}
.m1_download_data {
	width: 100px;
	height: 36px;
	background: #4eac41;
	border-radius: 1px;
	font-size: 12px;
	font-family: Source Han Sans CN;
	font-weight: 500;
	color: #ffffff;
	text-align: center;
	line-height: 36px;
	display: inline-block;
	float: right;
	cursor: pointer;
}

.el-range-editor.el-input__inner {
	border: 1px solid #e7ede5 !important;
}
.m1_info_ul {
	width: 100%;
	overflow: hidden;
	margin-top: 16px;
}

// table样式
.el-table .row_yellow {
	background: #f5f7f5 !important;
}

// 分页
.pagination_box {
	width: 100%;
	overflow: hidden;
	margin-bottom: 70px;
	margin-top: 50px;
	text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/mode7Child.vue